const SALESFORCE_ACTIVITY_QUERY_KEY = 'salesforceActivity';

export const salesforceActivityQueryKey = {
  tasks: (companyDomain: string) => [SALESFORCE_ACTIVITY_QUERY_KEY, companyDomain] as const,
};
